import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloud, faDesktop, faHandshake, faEnvelope, faLock, faBolt } from '@fortawesome/free-solid-svg-icons';
import { faCpanel } from '@fortawesome/free-brands-svg-icons';

import IMask from 'imask';
import { Link } from 'react-router-dom';

const WebHosting = () => {
    useEffect(() => {
        document.title = "Website Hosting | Riverland Technology Services"
        for(var element of document.getElementsByClassName("enquireBtn"))
        {
            element.addEventListener("click", () => {document.getElementById("enquire").scrollIntoView({behavior: "smooth"})});
        }
        var phonemask = IMask(document.getElementById("phoneInput"), {
            mask: [
                {
                    mask: '(00) 0000 0000'
                },
                {
                    mask: '+00 000 000 000'
                }
            ]
        });
    }, []);

    
    return (
       <>
           <section className="section ProductHeroSection WebDevProductHeroSection HeroSection Section--hasGuides theme--light accent--Blue">
                <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout ProductHeroSection_layout">
                                    <nav className="ProductNav">
                                        <header className="ProductNav_header">
                                            <FontAwesomeIcon className="ProductIcon ProductIcon--webDev ProductNav_icon" transform="up-1.5" icon={faCloud}/>
                                            <h1 className="ProductNav_title">Web Hosting</h1>
                                        </header>
                                        <div className="HorizontalOverflowContainer">
                                            <div className="HorizontalOverflowContainer_track">
                                                <div className="HorizontalOverflowContainer_items">
                                                    <ul className="ProductNav_linkList">
                                                        <li className="ProductNavItem ProductNavItem--isActive">
                                                            <Link to="/products/web-development" className="link">Overview</Link>
                                                        </li>
                                                        <li className="ProductNavItem">
                                                            <button className="link enquireBtn">Enquiries</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                    <div className="ProductHeroSection_content">
                                        <div className="RowLayout">
                                            <section className="Copy variant--Hero">
                                                <header className="Copy_header">
                                                    <h1 className="CopyTitle">
                                                        Fast, reliable website hosting
                                                    </h1>
                                                </header>
                                                <div className="Copy_body">
                                                    <p>
                                                        We can host your website for you. With our fast infrastruture, your website will load in no time, as our servers are based in Australia, meaning less latency, and faster loading times for your website. We can even set up a website server at your site, meaning you have full access to the server, and no monthly fees.
                                                    </p>
                                                </div>
                                                <footer className="Copy_footer">
                                                    <div className="Copy_footerContainer">
                                                        <button className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta enquireBtn">
                                                            Enquire
                                                            <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                                                <g fill-rule="evenodd">
                                                                    <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                                                    <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </footer>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section theme--white accent--Blue">
            <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout">
                                    <div>
                                        <div className="ColumnLayout" data-columns="1,1,1,1">
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faBolt} /></div>
                                                    <h1 className="CopyTitle">Fast Servers</h1>
                                                </header>
                                                <div className="Copy_body">
                                                    With our servers, located locally in Australia, we can offer the best experience for your visitors!
                                                </div>
                                            </div>
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faEnvelope} /></div>
                                                    <h2 className="CopyTitle">Custom eMail</h2>
                                                </header>
                                                <div className="Copy_body">
                                                    We include free, unlimited, @yourdomain email addresses, making your business look more professional.
                                                </div>
                                            </div>
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faCpanel} /></div>
                                                    <h2 className="CopyTitle">cPanel</h2>
                                                </header>
                                                <div className="Copy_body">
                                                    We use cPanel, the world's most used web hosting control panel, which makes support a breeze.
                                                </div>
                                            </div>
                                            <div className="Copy variant--Detail">
                                                <header className="Copy_header">
                                                    <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faLock} /></div>
                                                    <h2 className="CopyTitle">Free SSL</h2>
                                                </header>
                                                <div className="Copy_body">
                                                    We provide all our customers with the option to use a free SSL certificate from Let's Encrypt, making your website secure for all your visitors.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section theme--dark accent--Blue" id="enquire">
                <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout" style={{"--rowLayoutGap": "32px"}}>
                                    <div className="ColumnLayout" data-columns="2,2" data-tablet-columns="1">
                                        <div>
                                            <section className="Copy variant--Section HomepagePlatformCopy" style={{"--paddingRight": "16px", paddingBottom: "16px"}}>
                                                <header className="Copy_header">
                                                    <h2 className="CopyCaption">Enquiries</h2>
                                                    <h1 className="CopyTitle">Interested in fast, reliable web hosting?</h1>
                                                </header>
                                            </section>
                                            <section className="Copy variant--Section" style={{"--paddingRight": "var(--columnPaddingMedium)"}}>
                                                <div className="Copy_body">
                                                    <p>
                                                        We can help you run your website locally, with local, fast servers. If you are interested, please fill out the enquriry form.
                                                    </p>
                                                </div>
                                            </section>
                                        </div>
                                        <div>
                                            <section className="enquireForm">
                                                <div className="formContainer">
                                                    <form action="/api/v1/enquiries/enquire.php" method="post">
                                                        <input hidden name="enquireProduct" value="webhost"></input>
                                                        <ul className="formList">
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">First Name</span></div><div className="formInputContainer"><input className="formInput" type="text" name="firstNameInput" id="firstNameInput" placeholder="John" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Last Name</span></div><div className="formInputContainer"><input className="formInput" type="text" name="lastNameInput" id="lastNameInput" placeholder="Doe" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Email Address</span></div><div className="formInputContainer"><input className="formInput" type="email" name="emailInput" id="emailInput" placeholder="john@atom.tech" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Phone Number</span></div><div className="formInputContainer"><input className="formInput" type="text" name="phoneInput" id="phoneInput" placeholder="(xx) xxxx xxxx/+xx xxx xxx xxx" required /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Business Name</span><span className="formLabelDescription">Optional</span></div><div className="formInputContainer"><input className="formInput" type="text" name="businessNameInput" id="businessNameInput" placeholder="Atom Technology" /></div></li>
                                                            <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Notes</span><span className="formLabelDescription">Optional</span></div><div className="formInputContainer"><textarea className="formInput" type="textarea" name="notesInput" id="notesInput" /></div></li>
                                                        </ul>
                                                        <div className="formFooter">
                                                            <button type="submit" name="submit" className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta">
                                                                Submit
                                                                <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                                                    <g fill-rule="evenodd">
                                                                        <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                                                        <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                                                    </g>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
       </>
    );
}

export default WebHosting